import firebase from "firebase";
import Vue from "vue";

import { Dispatcher } from "@/store/helper/firestore";

import uuid from "uuid";

// TODO AuthDispatcher implementieren
//import { AuthDispatcher } from "@/store/helper/firebase_auth";

export const api = {
  namespace: "users",
  getters: {
    user: "user",
    isAuthenticated: "isAuthenticated",
    getLoadedUsers: "getLoadedUsers",
    getLoadedUsersByRole: "getLoadedUsersByRole",
    getUser: "getUser",
    getRolesByUser: "getRolesByUser",
    forceGetUserByText: "forceGetUserByText"
  },
  mutations: {
    resetState: "resetState",
    setUser: "setUser",
    setLoadedUsers: "setLoadedUsers",
    setLoadedRoles: "setLoadedRoles",
    createUser: "createUser",
    updateUser: "updateUser",
    deleteUser: "deleteUser",
    addUserToRole: "addUserToRole",
    deleteUserFromRole: "deleteUserFromRole"
  },
  actions: {
    loadUsers: "loadUsers",
    loadRoles: "loadRoles",
    userSignUp: "userSignUp",
    userSignInWithGoogle: "userSignInWithGoogle",
    userSignIn: "userSignIn",
    autoSignIn: "autoSignIn",
    userSignOut: "userSignOut",
    createUser: "createUser",
    createUserInactive: "createUserInactive",
    importUsers: "importUsers",
    updateUser: "updateUser",
    deleteUser: "deleteUser",
    updateRoles: "updateRoles",
    deleteRoles: "deleteRoles",
    addUserToRole: "addUserToRole",
    deleteUserFromRole: "deleteUserFromRole",
    enableProviderFirebase: "enableProviderFirebase",
    disableProviderFirebase: "disableProviderFirebase"
  },
  state: {
    user: "user",
    role: "role",
    loadedUsers: "loadedUsers",
    loadedRoles: "loadedRoles"
  }
};

const defaultState = () => {
  return {
    [api.state.loadedUsers]: [],
    [api.state.user]: null,
    [api.state.role]: null,
    [api.state.loadedRoles]: [
      { id: "user", description: "User" },
      { id: "auditor", description: "Auditor" },
      { id: "admin", description: "Administrator" },
      { id: "qm", description: "Quality Manager" }
    ]
  };
};

const state = defaultState();

const mutations = {
  [api.mutations.resetState](state) {
    Object.assign(state, defaultState());
  },
  [api.mutations.setLoadedUsers](state, payload) {
    console.assert(
      payload && payload instanceof Array,
      "setLoadedUsers: payload invalid"
    );
    if (payload && payload instanceof Array) {
      state.loadedUsers = payload;
    }
  },
  [api.mutations.setLoadedRoles](state, payload) {
    console.log("Roles are set");
    state.loadedRoles = payload;
  },
  [api.mutations.createUser](state, payload) {
    const item_id = payload.item_id;
    console.log("User ID", item_id);
    state.loadedUsers.push({ ...payload.data, id: item_id });
  },
  [api.mutations.updateUser](state, payload) {
    const data = payload.data;
    const user_id = payload.user_id;

    const user_index = state.loadedUsers.findIndex(user => user.id === user_id);

    Vue.set(state.loadedUsers, user_index, data);
  },
  [api.mutations.deleteUser](state, payload) {
    const user_index = payload.user_index;

    state.loadedUsers.splice(user_index, 1);
  },
  [api.mutations.setUser](state, payload) {
    state.user = payload;
  },
  [api.mutations.addUserToRole](state, payload) {
    const data = payload.data;
    const user_id = payload.user_id;
    const role_id = payload.role_id;

    console.log("Add User 2 r", payload);

    const role_index = state.loadedRoles.findIndex(role => role.id === role_id);

    Vue.set(state.loadedRoles[role_index].members, user_id, data);
  },
  [api.mutations.deleteUserFromRole](state, payload) {
    const user_id = payload.user_id;
    const role_id = payload.role_id;

    console.log("Delete User 2 r", payload, state.loadedRoles);

    const role_index = state.loadedRoles.findIndex(role => role.id === role_id);

    Vue.delete(state.loadedRoles[role_index].members, user_id);
  }
};

const actions = {
  async [api.actions.loadUsers]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      dispatch("app/setLoading", false, { root: true });
      firebase
        .firestore()
        .collection("users")
        .get()
        .then(snapshot => {
          const users = [];
          snapshot.forEach(doc => {
            const user = doc.data();
            const key = doc.id;
            users.push({ ...user, id: key });
          });
          console.log("Fetch user data from firebase", users);
          commit("setLoadedUsers", users);
          dispatch("app/setLoading", false, { root: true });
          resolve(true);
        })
        .catch(error => {
          console.log(error);
          dispatch("app/setLoading", false, { root: true });
          reject(false);
        });
    });
  },
  async [api.actions.loadRoles]({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      dispatch("app/setLoading", false, { root: true });

      firebase
        .firestore()
        .collection("roles")
        .get()
        .then(snapshot => {
          let promises = [];
          const roles = [];
          snapshot.forEach(doc => {
            const role = doc.data();
            const key = doc.id;
            //roles.push({ ...role, id: key });
            const promise = doc.ref
              .collection("members")
              .where("active", "==", true)
              .get()
              .then(snapshot => {
                let members = {};
                snapshot.forEach(doc => {
                  members[doc.id] = true;
                });
                const role_map = {
                  ...role,
                  id: key,
                  members: members
                };
                roles.push(role_map);
                Promise.resolve(role_map);
              });
            promises.push(promise);
          });

          Promise.all(promises)
            .then(result => {
              console.log("Fetch roles data from firebase", roles, result);
              commit("setLoadedRoles", roles);
              dispatch("app/setLoading", false, { root: true });
              resolve(true);
            })
            .catch(error => {
              dispatch("app/setLoading", false, { root: true });
              reject(error);
            });
        })
        .catch(error => {
          console.log(error);
          dispatch("app/setLoading", false, { root: true });
          reject(false);
        });
    });
  },
  async [api.actions.userSignUp]({ commit, dispatch }, payload) {
    console.log("userSignUp", commit, dispatch, payload);
    /* DISABLE SIGN UP
    dispatch("app/setLoading", true, { root: true });

    firebase
      .auth()
      .createUserWithEmailAndPassword(payload.email, payload.password)
      .then(firebaseUser => {
        console.log("Firebase User");

        const local_payload = {
          data: {
            firebase_id: firebaseUser.user.uid,
            email: firebaseUser.user.email,
            displayName: firebaseUser.user.displayName,
            avatar: firebaseUser.user.photoURL
          }
        };
        console.log("User Sign Up", local_payload);

        // User in Firebase DB anlegen
        dispatch("createUser", local_payload);

        // User Object anlegen
        commit("setUser", {
          id: firebaseUser.user.uid,
          email: firebaseUser.user.email
        });
        //router.push("/");
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(error => {
        //commit("setError", error.message);
        dispatch("app/setLoading", false, { root: true });
      });
      */
  },
  async [api.actions.userSignIn]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });

    try {
      let firebaseUser = await firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password);

      /*
      let local_payload = {
        data: {
          firebase_id: firebaseUser.user.uid,
          email: firebaseUser.user.email,
          displayName: firebaseUser.user.displayName || firebaseUser.user.email,
          avatar: firebaseUser.user.photoURL
        }
      };
      */

      let firebase_user_id = firebaseUser.user.uid;

      await dispatch("loadUsers");

      let firebase_ref = await firebase.firestore().collection("users");

      firebase_ref
        .orderBy("firebase_id")
        .equalTo(firebase_user_id)
        .get()
        .then(userssnapshot => {
          if (!userssnapshot.empty) {
            userssnapshot.forEach(function(snapshot) {
              let payload = { ...snapshot.val() };
              console.log("Payload userSignIn", payload);
              //commit("setUser", local_payload.data);
              commit("setUser", payload);
            });
          } else {
            commit("setUser", payload.data);
          }
        })
        .catch(err => {
          console.error("Error setting user", err);
        });

      dispatch("app/setLoading", false, { root: true });
    } catch (err) {
      dispatch("app/setLoading", false, { root: true });
    }
  },
  async [api.actions.userSignInWithGoogle]({ commit, dispatch }) {
    dispatch("app/setLoading", true, { root: true });

    try {
      const provider = new firebase.auth.GoogleAuthProvider();

      console.log("Google Login");

      let firebaseUser = await firebase.auth().signInWithPopup(provider);

      console.log("USER OBJECT", firebaseUser);

      let local_payload = {
        data: {
          //firebase_id: firebaseUser.user.uid,
          email: firebaseUser.user.email || "",
          displayName: firebaseUser.user.displayName || firebaseUser.user.email,
          avatar: firebaseUser.user.photoURL
        }
      };

      console.log("FB Google", local_payload);

      let firebase_user_id = firebaseUser.user.uid;

      console.log("FB Google II", firebase_user_id);

      let firebase_ref = await firebase.firestore().collection("users");

      firebase_ref
        //.orderByChild("firebase_id")
        .equalTo(firebase_user_id)
        .get()
        .then(userssnapshot => {
          if (!userssnapshot.empty) {
            userssnapshot.forEach(function(snapshot) {
              let payload = { ...snapshot.val() };
              commit("setUser", payload);
            });
          } else {
            // Sign Out, if the User is not connected
            firebase.auth().signOut();
            commit("setUser", null);
          }
        });

      dispatch("app/setLoading", false, { root: true });
    } catch (err) {
      dispatch("app/setLoading", false, { root: true });
    }
  },
  async [api.actions.enableProviderFirebase]({ commit, dispatch }, payload) {
    // TODO: Insgesamt sollte dieser Prozess im Backend geschützt sein!
    const ref = "users";
    const doc = payload.user_id;
    console.log(doc);
    const email = payload.data.email;
    // TODO: Security
    const password = uuid.v4();

    // TODO: Workarround, because otherwise the new user is logged in directly:
    const secondfb = firebase.initializeApp(
      JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG),
      "Secondary"
    );
    try {
      const firebase_user = await secondfb
        .auth()
        .createUserWithEmailAndPassword(email, password);
      console.log("Firebase User", firebase_user.user.uid);
      const firebase_uid = firebase_user.user.uid;
      secondfb.delete();

      const mutation = "updateUser";

      let data = {
        ...payload.data,
        firebase_id: firebase_uid,
        firebase_active: true
      };
      payload = { ...payload, data: data };
      console.log("epf", payload);

      Dispatcher.updateAsync({ ref, doc, payload, commit, mutation })
        .then(input => {
          console.log("Yes go", input);
          dispatch(
            "app/addStatus",
            { message: "User update successful", type: "success" },
            { root: true }
          );
          return Promise.resolve(input);
        })
        .catch(err => {
          console.error("No go", err);
          dispatch(
            "app/addStatus",
            { message: err.message, type: "error" },
            { root: true }
          );
          return Promise.reject();
        });
    } catch (err) {
      secondfb.delete();
      console.log("Das ist ein Fehler", err);
      dispatch(
        "app/addStatus",
        { message: err.message, type: "error" },
        { root: true }
      );
      return Promise.reject();
    }
  },
  async [api.actions.disableProviderFirebase]({ commit }, payload) {
    console.log(commit, payload);
    /*
    const ref = "users"
    const user_id = payload.user_id
    const doc = user_id
    const email = payload.data.email
    // TODO: Security
    const password = uuid.v4()

    const admin = firebase.admin()

    // TODO: Trigger Firebase Function, to disable current User -> Check for Admin Role
    */
    /*const mutation = "updateUser";

    let data = {...payload.data, firebase_active: false }
    payload = { ...payload, data: data }

    return Dispatcher.updateAsync({ ref, doc, payload, commit, mutation }); */
  },
  async [api.actions.userConnectWithGoogle]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });

    const provider = new firebase.auth.GoogleAuthProvider();

    let currentUser = payload.data;

    firebase
      .auth()
      .signInWithRedirect(provider)
      .then(firebaseUser => {
        currentUser = {
          ...currentUser,
          google: { id: firebaseUser.uid, email: firebaseUser.email }
        };

        let currentPayload = { ...payload, data: currentUser };

        dispatch("updateUser", currentPayload);
        commit("setUser", { id: firebaseUser.uid, email: firebaseUser.email });

        console.log("login accomplished");
        dispatch("app/setLoading", false, { root: true });
      })
      .catch(error => {
        console.error(error);
        //commit("setError", error.message);
        dispatch("app/setLoading", false, { root: true });
      });
  },
  async [api.actions.autoSignIn]({ commit, dispatch }, payload) {
    dispatch("app/setLoading", true, { root: true });

    const firebaseUser = payload;

    if (!payload) {
      return;
    }

    const firebase_user_id = firebaseUser.uid;

    let firebase_ref = await firebase.firestore().collection("users");

    firebase_ref
      .where("firebase_id", "==", firebase_user_id)
      .get()
      .then(userssnapshot => {
        if (!userssnapshot.empty) {
          userssnapshot.forEach(doc => {
            let payload = { ...doc.data() };
            //commit("setUser", local_payload.data);
            commit("setUser", payload);
          });
        } else {
          //let x = await dispatch("setLoadedUsers")
          //dispatch("createUser", local_payload);
          //console.log("Nutzer wird angelegt");
          console.log("Payload");
          commit("setUser", payload.data);
        }
      });

    dispatch("app/setLoading", false, { root: true });
  },
  async [api.actions.userSignOut]({ commit, dispatch }) {
    dispatch("app/setLoading", true, { root: true });
    firebase.auth().signOut();
    commit("setUser", null);
    console.log("logout accomplished");
    dispatch("unloadState", "", { root: true });
    console.log("unload state accomplished");
    dispatch("app/setLoading", false, { root: true });
  },
  async [api.actions.createUserInactive]({ commit }, payload) {
    const ref = "users";
    const mutation = "createUser";

    // TODO: Wir müssen uns hier noch mal die Struktur überlegen, ob die primäre User ID aus der AuditCloud kommt -> Denke ja!

    //let data = {...payload.data, id: firebase_uid, firebase_id: firebase_uid }
    //payload = { ...payload, data: data }

    console.log("Action - Create user Inactive");
    console.log(payload);

    const new_user_id = Dispatcher.createAsync({
      ref,
      payload,
      commit,
      mutation
    });
    return new_user_id;
  },
  async [api.actions.createUser]({ commit, dispatch }, payload) {
    const ref = "users";
    const email = payload.data.email;
    // TODO: Security
    const password = uuid.v4();

    // TODO: Workarround, because otherwise the new user is logged in directly:
    const secondfb = firebase.initializeApp(
      JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG),
      "Secondary"
    );
    try {
      const firebase_user = await secondfb
        .auth()
        .createUserWithEmailAndPassword(email, password);

      console.log("Firebase User", firebase_user.user.uid);
      const firebase_uid = firebase_user.user.uid;
      secondfb.delete();

      const doc = firebase_uid || "";
      const mutation = "createUser";

      let data = {
        ...payload.data,
        id: firebase_uid,
        firebase_id: firebase_uid
      };

      payload = { ...payload, data: data };

      console.log("Action - Create user");
      console.log(payload);

      const user_id = await Dispatcher.createAsync({
        ref,
        doc,
        payload,
        commit,
        mutation
      })
        .then(input => {
          console.log("Yes go", input);
          dispatch(
            "app/addStatus",
            { message: "User creation successful", type: "success" },
            { root: true }
          );
          return Promise.resolve(input);
        })
        .catch(err => {
          console.error("No go", err);
          dispatch(
            "app/addStatus",
            { message: err.message, type: "error" },
            { root: true }
          );
          return Promise.reject();
        });

      console.log("UserIDD", user_id);
      return user_id;
    } catch (err) {
      // Handle Errors here.
      var errorCode = err.code;
      var errorMessage = err.message;

      // Status-Message
      const status = {
        type: "error",
        code: errorCode,
        message: errorMessage
      };
      dispatch("app/addStatus", status, { root: true });

      console.log("Das ist ein Fehler", err);
    }
  },
  async [api.actions.updateUser]({ commit, dispatch }, payload) {
    const ref = "users";
    const doc = payload.user_id;
    const mutation = "updateUser";

    console.log("Action - Update user");
    console.log(payload);

    Dispatcher.updateAsync({ ref, doc, payload, commit, mutation })
      .then(input => {
        console.log("Yes go", input);
        dispatch(
          "app/addStatus",
          { message: "User update successful", type: "success" },
          { root: true }
        );
        return Promise.resolve(input);
      })
      .catch(err => {
        console.error("No go", err);
        dispatch(
          "app/addStatus",
          { message: err.message, type: "error" },
          { root: true }
        );
        return Promise.reject();
      });
  },
  async [api.actions.deleteUser]({ commit }, payload) {
    const ref = "users";
    const doc = payload.user_id;
    const child = "";
    const mutation = "deleteUser";

    console.log("Action - Delete User");
    console.log(payload);

    Dispatcher.deleteAsync({ ref, doc, child, payload, commit, mutation });
  },
  async [api.actions.importUsers]({ dispatch }, payload) {
    const users = payload.data;
    const iam = false;

    for (let key in users) {
      const payload = {
        data: users[key]
      };
      if (iam) {
        dispatch("createUser", payload);
      } else {
        dispatch("createUserInactive", payload);
      }
    }
  },
  async [api.actions.uploadAvatar]({ commit }, payload) {
    let ref = "attachments";
    let child = "child";
    let mutation = "";

    Dispatcher.uploadAsync({ ref, child, payload, commit, mutation })
      .then(downloadURL => {
        console.log("Media Upload sucessful", downloadURL);
      })
      .catch(error => {
        console.log(error);
      });
  },
  async [api.actions.updateRoles]({ commit }, payload) {
    // TODO: Wie bekommen wir hier am besten die möglichen Rollen rein?
    const roles = payload.data;
    const user_id = payload.user_id;

    // TODO - Mapping of roles
    /*
    let role_map = [
      { from: "user", to: "user" },
      { from: "auditor", to: "auditor" },
      { from: "qm", to: "qm" },
      { from: "admin", to: "admin" }
    ];
    */

    const ref = "roles";
    const subcollection = "members";

    const db = firebase.firestore();

    for (let key in roles) {
      // let child = roles[key].id + "/members/" + user_id;
      if (roles[key].member) {
        const payload = {
          data: true,
          role_id: roles[key].id,
          user_id: user_id
        };
        //let mutation = "addUserToRole";
        //Dispatcher.updateAsync({ ref, child, payload, commit, mutation });

        db.collection(ref)
          .doc(roles[key].id)
          .collection(subcollection)
          .doc(user_id)
          .set({
            active: true
          })
          .then(() => {
            console.log("User added to role", payload.role_id);
            commit("addUserToRole", payload);
          })
          .catch(err => {
            console.log("Error", err);
          });
      } else {
        const payload = {
          data: false,
          role_id: roles[key].id,
          user_id: user_id
        };
        // let mutation = "deleteUserFromRole";
        //Dispatcher.deleteAsync({ ref, child, payload, commit, mutation });

        db.collection(ref)
          .doc(roles[key].id)
          .collection(subcollection)
          .doc(user_id)
          .delete()
          .then(() => {
            console.log("User deleted from role", payload.role_id);
            commit("deleteUserFromRole", payload);
          })
          .catch(err => {
            console.log("Error", err);
          });
      }
    }
  },
  async [api.actions.deleteRoles]({ commit }, payload) {
    console.warn("deleteRoles", commit, payload);
    /*
    const roles = payload.data;
    const user_id = payload.user_id;

    const ref = "roles";
    const doc = role_id;
    const subcollection = "members";
    const childdoc = user_id;
    const mutation = "addUserToRole";

    // const db = firebase.firestore();

    console.log("NYI, delete Roles");

    /*for (let key in roles) {
      let child = roles[key].id + "/members/" + user_id;
        let mutation = "deleteUserFromRole";
        Dispatcher.deleteAsync({ ref, child, payload, commit, mutation });
    }*/
  },
  async [api.actions.addUserToRole]({ commit }, payload) {
    console.log("Action - Add user to role");
    console.log(commit, payload);

    const role_id = payload.role_id;
    const user_id = payload.user_id;

    const ref = "roles";
    const doc = role_id;
    const subcollection = "members";
    // const childdoc = user_id;
    // const mutation = "addUserToRole";

    const db = firebase.firestore();

    db.collection(ref)
      .doc(doc)
      .collection(subcollection)
      .doc(user_id)
      .set({
        active: true
      })
      .then(() => {
        console.log("User added to role", role_id);
      })
      .catch(err => {
        console.log("Error", err);
      });

    //Dispatcher.setAsync({ ref, doc, child, payload, commit, mutation });
  },
  async [api.actions.deleteUserFromRole]({ commit }, payload) {
    const ref = "roles";
    const child = payload.role_id + "/members";
    const mutation = "deleteUserFromRole";

    console.log("Action - Delete user from role");
    console.log(payload);

    Dispatcher.deleteAsync({ ref, child, payload, commit, mutation });
  }
};

const getters = {
  [api.getters.isAuthenticated](state) {
    return state.user !== null && state.user !== undefined;
  },
  [api.getters.user](state) {
    return state.user;
  },
  [api.getters.getLoadedUsers](state) {
    //TODO: ACHTUNG - Selects benötigen Arrays
    //console.log(state.loadedUsers);
    return state.loadedUsers;
  },
  [api.getters.getLoadedUsersByRole](state, getters) {
    // TODO: Keine schöne Implementierung. Müssen wir verbessern.

    return roleId => {
      const user_roles = state.loadedRoles.filter(item => {
        return item.id === roleId;
      });

      const filteredusers = [];
      const unknown_firebase_ids = [];

      for (const user_role of user_roles) {
        for (let user_firebase_id of Object.keys(user_role.members)) {
          const user = getters.getUser(user_firebase_id, "firebase_id");
          if (user) {
            filteredusers.push(user);
          } else {
            unknown_firebase_ids.push(user_firebase_id);
          }
        }
      }
      console.warn(
        `Found unmappable firebase_id ${unknown_firebase_ids} for member of role "${roleId}"`
      );
      return filteredusers;
    };
  },
  [api.getters.getUser](state) {
    return (user_id, field) => {
      if (!field) {
        field = "id";
      }
      return state.loadedUsers.find(user => {
        return user[field] === user_id;
      });
    };
  },
  [api.getters.forceGetUserByText](state) {
    return Text => {
      let user = state.loadedUsers.find(user => user.id === Text);
      if (typeof user == "undefined") {
        console.warn(
          "user id unmapable try firebase_id",
          Text,
          state.loadedUsers
        );
        user = state.loadedUsers.find(user => user.firebase_id === Text);
      }
      if (typeof user == "undefined") {
        console.warn(
          "user firebase_id unmapable try email",
          Text,
          state.loadedUsers
        );
        user = state.loadedUsers.find(user => user.email === Text);
      }
      if (typeof user == "undefined") {
        console.warn(
          "user email unmapable try displayName",
          Text,
          state.loadedUsers
        );
        user = state.loadedUsers.find(user => user.displayName === Text);
      }
      if (typeof user == "undefined") {
        console.error("user not found", Text, state.loadedUsers);
      }
      return user || null;
    };
  },
  [api.getters.getRolesByUser](state) {
    return user_id => {
      let filteredRoles = state.loadedRoles;
      let result = [];
      for (let key in filteredRoles) {
        if (filteredRoles[key].members[user_id]) {
          result.push({
            id: filteredRoles[key].id,
            description: filteredRoles[key].description,
            member: true
          });
        } else {
          result.push({
            id: filteredRoles[key].id,
            description: filteredRoles[key].description,
            member: false
          });
        }
      }
      return result;
    };
  }
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};

// TODO: Ist das eine clevere Möglichkeit Dummy-User für die Auto-Completes zu importieren?
/*
function usertemplate() {
  return [
    {
      firebase_id: "nQHrH0TunQQqFCzsYYGcVvfgsYx1",
      displayName: "Alexander Stoffers",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/audit-cloud-5771e.appspot.com/o/static%2Favatars%2F5.jpg?alt=media&token=4fbacfb1-084d-44ff-bab0-44122e39cfef",
      email: "stoffers@productify.eu"
    }
  ];
}
*/
